import React, { Component } from 'react';
import autoBind from 'react-autobind/src/autoBind';
import TableHelper from 'src/utils/table-helper';
import { withTranslation } from 'react-i18next';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { asyncRequest, Entities, TOMCAT_URL } from 'src/common';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import moment from 'moment';
import EmailToJourneyEditModal from 'src/components/administration/email-to-journey/components/email-to-journey-edit-modal';
import EmailToJourneyInfoModal from 'src/components/administration/email-to-journey/components/email-to-journey-info-modal';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import OpenFolderIcon from 'material-ui/svg-icons/file/folder-open';
import { blue700, green400, red400 } from 'material-ui/styles/colors';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import ClosedFolderIcon from 'material-ui/svg-icons/file/folder';

let SelectableList = makeSelectable(List);

class EmailToJourneyOperator extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper();
        this.state = {
            startedFetching: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        const { emailToJourneyItems } = nextProps;

        if (emailToJourneyItems.isFetching && !this.state.startedFetching) this.setState({ startedFetching: true });

        this.tableHelper.processPagination(emailToJourneyItems.items.length);
    }

    componentWillMount() {
        this.props.fetchAllCustomRepository(Entities.EMAIL_TO_OFFER, 'get-all-by-company');
    }

    componentDidMount() {
        const { busCompany, push } = this.props;
        if (busCompany.entity && !busCompany.entity.emailToRouteStoreModuleActive) push('/');
    }

    componentDidUpdate(prevProps) {
        if (
            this.tableHelper.processPaginationAfterUpdate(
                prevProps.emailToJourneyItems,
                this.props.emailToJourneyItems,
                this.table,
            )
        )
            this.setState({ renderSelection: !this.state.renderSelection });
    }

    render() {
        const { emailToJourneyItems } = this.props;
        const tableData = [];
        const finishFetching = this.state.startedFetching && !emailToJourneyItems.isFetching;

        if (finishFetching && emailToJourneyItems.items.length > 0) {
            emailToJourneyItems.items.map(entry => {
                tableData.push({
                    id: entry.id,
                    createdAt: moment(entry.createdAt).format('DD.MM.YYYY HH:mm:ss'),
                    token: entry.token,
                    internalReference: entry.internalReference,
                    openAIPositiveAnswer: entry.openAIPositiveAnswer,
                    booking: entry.booking,
                    insufficientResponse: entry.insufficientResponse,
                });
            });
        }

        const { t } = this.props;
        return (
            <>
                <div className="col-md-2 sidebar-listview">
                    <SelectableList
                        selectedItemStyle={{
                            backgroundColor: '#0a71ba1a',
                        }}
                        value={1}
                        onChange={() => this}>
                        <ListItem
                            className="styled-list-item"
                            key={2}
                            primaryText={t('offers.back_to_offers')}
                            leftIcon={<ArrowBack color={blue700} />}
                            onClick={() => this.props.push('/offer-administration')}
                        />
                    </SelectableList>
                </div>
                <div className="col-md-10">
                    <legend className="legend">{t('email_to_journey.title')}</legend>
                    <button
                        className="btn btn-xs btn-blue btn-flex pull-right"
                        onClick={() => {
                            if (this.table) this.table.reset();
                            this.props.openModal({
                                component: EmailToJourneyEditModal,
                                componentProps: {
                                    isCreate: true,
                                    refetch: () =>
                                        this.props.fetchAllCustomRepository(
                                            Entities.EMAIL_TO_OFFER,
                                            'get-all-by-company',
                                        ),
                                },
                                title: t('email_to_journey.title'),
                                noButtons: true,
                                mandatoryFields: true,
                            });
                        }}>
                        <span className="glyphicon glyphicon-plus" />
                        {t('email_to_journey.request')}
                    </button>
                    <BootstrapTableErrorBoundary>
                        <BootstrapTable
                            ref={ref => (this.table = ref)}
                            data={tableData}
                            exportCSV={true}
                            striped={true}
                            hover={true}
                            condensed={true}
                            pagination={true}
                            options={Object.assign({}, this.tableHelper.getOptions(finishFetching))}
                            selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                            searchPlaceholder={t('common_phrases.search')}
                            search={true}>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="id"
                                hidden={false}
                                width="30"
                                isKey={true}
                                export={true}>
                                {t('common_phrases.id')}
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} width="50" dataField="createdAt" dataSort={true}>
                                {t('find_my_bus.requested')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                width="50"
                                dataField="internalReference"
                                dataSort={true}>
                                {t('email_to_journey.internal_reference')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="booking"
                                width="20"
                                dataFormat={this.requestStatus}
                                csvFormat={this.requestStatus}>
                                Status
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="insufficientResponse"
                                width="20"
                                dataFormat={this.insufficientResponseStatus}
                                csvFormat={this.insufficientResponseStatus}>
                                {t('email_to_journey.trip_data')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="actions"
                                width="90"
                                dataFormat={this.tableActionsFormatter}
                                export={false}>
                                {t('common_phrases.actions')}
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </BootstrapTableErrorBoundary>
                </div>
            </>
        );
    }

    insufficientResponseStatus(insufficientResponse) {
        const { t } = this.props;
        if (insufficientResponse)
            return (
                <span title={t('email_to_journey.status.insufficient_response')}>
                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="10" fill={red400} />
                    </svg>
                </span>
            );
        return (
            <span title={t('email_to_journey.status.sufficient_response')}>
                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="10" fill={green400} />
                </svg>
            </span>
        );
    }

    requestStatus(request) {
        const { t } = this.props;
        if (request == null)
            return (
                <span title={t('bus_requests.filter.offer_missing')}>
                    <OpenFolderIcon color={red400} />
                </span>
            );
        if (request)
            return (
                <span title={t('bus_requests.filter.offer_created')}>
                    <ClosedFolderIcon color={blue700} />
                </span>
            );
    }

    tableActionsFormatter(cell, row) {
        const { t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() => {
                        asyncRequest(`${TOMCAT_URL}api/${Entities.EMAIL_TO_OFFER.repository}/create-link/${row.token}`)
                            .then(response => {
                                const json = response.json;
                                if (json && json.url) {
                                    const win = window.open(json.url, '_blank');
                                    if (win != null) win.focus();
                                }
                            })
                            .catch(error => console.error('Error creating Link', error));
                    }}>
                    <span className="glyphicon glyphicon-log-out text-info" />
                </button>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() => {
                        this.props.openModal({
                            component: EmailToJourneyInfoModal,
                            componentProps: {
                                emailToJourney: row,
                                refetch: () =>
                                    this.props.fetchAllCustomRepository(Entities.EMAIL_TO_OFFER, 'get-all-by-company'),
                            },
                            title: t('email_to_journey.title'),
                            noButtons: true,
                            singleButton: true,
                        });
                    }}>
                    <span className="glyphicon glyphicon-info-sign text-info" />
                </button>
            </div>
        );
    }
}

export default withTranslation()(composeModalActions(EmailToJourneyOperator));
